import React from 'react';

import IconButtonLink from '@dashboard/components/mui-atoms/IconButtonLink';
import { HelpOutlineOutlined } from '@mui/icons-material';
import { Box, Paper, Stack, SxProps, Tooltip, Typography } from '@mui/material';

type Props = {
  title: JsxNode;
  helpUrl?: string;
  children?: React.ReactNode;
  actions?: JsxNode;
  sx?: SxProps;
  headerSx?: SxProps;
};
export default function BaseSettingCard({ children, title, helpUrl, actions, sx = {}, headerSx = {} }: Props) {
  const renderTitle = () => {
    if (typeof title === 'string') {
      return <Typography variant="h4">{title}</Typography>;
    }
    return title;
  };

  const renderHelpIcon = () => {
    if (!helpUrl) {
      return null;
    }
    return (
      <Tooltip title="View in docs">
        <div>
          <IconButtonLink href={helpUrl} target="_blank">
            <HelpOutlineOutlined fontSize="small" />
          </IconButtonLink>
        </div>
      </Tooltip>
    );
  };

  return (
    <Paper sx={{ px: { xs: 3, md: 4 }, py: 4, ...sx }}>
      <Box
        sx={{
          mb: children ? 2 : 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          ...headerSx,
        }}
      >
        <Stack spacing={0.25} direction="row" alignItems="center">
          {renderTitle()}
          {renderHelpIcon()}
        </Stack>
        {actions}
      </Box>

      {children}
    </Paper>
  );
}
